import CacheUtils from '../utils/CacheUtils';
import { BaseService, getCacheQueryString } from './BaseService';

export interface IUseBrowserCache {
    user: string;
    useBrowserCache: boolean;
}

export interface IAppConfigValue {
    Value: string;
    Category?: string;
    CategoryTitle?: string;
}

export interface IAppDropdownConfigValue {
    name: string;
    icon: string | undefined;
    title: string;
    description: string;
}

export class AppConfigService extends BaseService {
    public getConfigSingleValueAsync = async (
        key: string,
        accessToken: string,
        browserCache: IUseBrowserCache,
    ): Promise<IAppConfigValue> => {
        const dataCacheKey = browserCache.user ? `getConfigSingleValueAsync.${key}.${browserCache.user}` : '';
        const cachedData: any =
            browserCache.useBrowserCache && dataCacheKey ? CacheUtils.getStoredDataByKey(dataCacheKey, true) : null;

        if (cachedData) {
            return cachedData;
        } else {
            const result = await this.getResponseAsync<IAppConfigValue>(
                {
                    commandPath: `appConfig/getConfigValue?key=${key}${getCacheQueryString('clearCache', '&')}`,
                    method: 'GET',
                },
                accessToken,
            );

            if (browserCache.useBrowserCache && dataCacheKey) {
                CacheUtils.setStoredDataByKey(dataCacheKey, result, CacheUtils.dataCacheExpires24Hours, true);
            }

            return result;
        }
    };

    public getConfigMultipleValues = async (
        key: string,
        accessToken: string,
        browserCache: IUseBrowserCache,
    ): Promise<IAppConfigValue[]> => {
        const dataCacheKey = browserCache.user ? `getConfigMultipleValues.${key}.${browserCache.user}` : '';
        const cachedData: any =
            browserCache.useBrowserCache && dataCacheKey ? CacheUtils.getStoredDataByKey(dataCacheKey, true) : null;

        if (cachedData) {
            return cachedData;
        } else {
            const result = await this.getResponseAsync<IAppConfigValue[]>(
                {
                    commandPath: `appConfig/getConfigValues?key=${key}${getCacheQueryString('clearCache', '&')}`,
                    method: 'GET',
                },
                accessToken,
            );

            if (browserCache.useBrowserCache && dataCacheKey) {
                CacheUtils.setStoredDataByKey(dataCacheKey, result, CacheUtils.dataCacheExpires24Hours, true);
            }

            return result;
        }
    };

    public getConfigDropdownValues = async (
        accessToken: string,
        browserCache: IUseBrowserCache,
    ): Promise<IAppDropdownConfigValue[]> => {
        const dataCacheKey = browserCache.user ? `getConfigDropdownValues.${browserCache.user}` : '';
        const cachedData: any =
            browserCache.useBrowserCache && dataCacheKey ? CacheUtils.getStoredDataByKey(dataCacheKey, true) : null;

        if (cachedData) {
            return cachedData;
        } else {
            const result = await this.getResponseAsync<IAppDropdownConfigValue[]>(
                {
                    commandPath: `appConfig/GetDropdownConfigAsync${getCacheQueryString('clearCache', '?')}`,
                    method: 'GET',
                },
                accessToken,
            );

            if (browserCache.useBrowserCache && dataCacheKey) {
                CacheUtils.setStoredDataByKey(dataCacheKey, result, CacheUtils.dataCacheExpires24Hours, true);
            }

            return result;
        }
    };

    public getSupportedFileTypes = async (
        //key: string,
        accessToken: string,
        browserCache: IUseBrowserCache,
    ): Promise<string[]> => {
        const dataCacheKey = browserCache.user ? `getSupportedFileTypes.${browserCache.user}` : '';
        const cachedData: any =
            browserCache.useBrowserCache && dataCacheKey ? CacheUtils.getStoredDataByKey(dataCacheKey) : null;

        if (cachedData) {
            return cachedData;
        } else {
            const result = await this.getResponseAsync<string[]>(
                {
                    commandPath: `appConfig/GetSupportedFileTypesAsync${getCacheQueryString('clearCache', '?')}`,
                    method: 'GET',
                },
                accessToken,
            );

            if (browserCache.useBrowserCache && dataCacheKey) {
                CacheUtils.setStoredDataByKey(dataCacheKey, result, CacheUtils.dataCacheLongExpiresMin);
            }

            return result;
        }
    };
}
